export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fb29cb4a6ae94b6d8ad2a1d8044beb5d2d0eab278&name=fetchTypeahead!'